module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_c('i', [_vm._v("One • A Long Friday")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_c('i', [_vm._v("Two • First Kaddish")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part02"
    }
  }, [_vm._v("PART TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003"
    }
  }, [_c('i', [_vm._v("Three • Before Memory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Four • The Protective Circle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Five • Growing Up and Away")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Six • Adolescence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Seven • Perspective")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Eight • A Soldier in His Army")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Nine • My Father, His Daughter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ten • The Six-Day War")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Eleven • Between Two Wars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Twelve • 1973–1977")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Thirteen • Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fourteen • Two Years in My Father’s Death")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fifteen • Shiva")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sixteen • Last Kaddish")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0